var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthworm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1036 0 0 1.1036 -130.04 -223.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.29 398.08c-18.571 75.714 15.714 41.429 15.714 97.143s-34.286 77.143-7.1429 105.71 51.429-24.286 115.71-15.714 51.429 31.429 91.429 32.857 78.571-31.429 101.43-35.714 34.286 24.286 81.429 37.143 55.714 5.7143 82.857-12.857-2.8571-38.571-45.714-30-52.857-55.714-101.43-47.143-62.857 35.714-88.571 27.143-64.286-55.714-134.29-31.429-50-18.571-35.714-40-42.857-27.143-21.429-67.143-12.053-14.036 7.1428-48.571c28.442-51.17 34.2-79.778 2.8572-128.57-21.797-33.933-54.286-48.571-90 10s-10 100 25.714 147.14z",
    fill: "#d45500",
    stroke: "#000",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.12 218.94c-5.0258 9.4085-14.995 14.133-23.425 19.82-13.798 11.997-18.886 30.723-21.666 48.12-4.5918 34.524 6.3827 69.726 25.809 98.167 8.358 13.789 12.767 29.798 12.906 45.895 1.9912 17.716 8.3433 34.621 16.038 50.547 4.9414 21.027-0.94283 42.5-5.7011 62.975-4.388 13.388-8.3197 27.395-6.804 41.6-0.76212 2.0367 0.95935 4.8728 1.1875 1.2188 1.7121-10.151 1.5094-21.093 7.5312-29.938 6.175-13.357 7.8435-28.113 10.034-42.475 3.615-16.57 7.2861-35.009-1.1837-50.777-7.4484-17.771-5.0404-37.866-12.295-55.726-5.4796-15.96-14.564-30.408-24.787-43.689-8.3209-17.129-3.6743-36.799 1.0328-54.255 5.4687-17.667 17.693-32.315 31.573-44.109 10.754-13.648 5.7808-34.428-6.125-45.719-0.98381-0.56843-3.5143-3.5726-4.125-1.6562z",
    fill: "#ff7f2a"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.7126 0 0 6.8447 -2074 -2241.3)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-202.86 -65.714)",
    stroke: "#000",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m385.42 380.31c-10.435-3.4028-17.162-19.633-15.025-36.251s12.328-27.331 22.762-23.929 17.162 19.633 15.025 36.251c-2.1193 16.483-12.171 27.183-22.545 23.998",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(7.0711 4.9898)",
    d: "m380.42 367.2c-2.4595-1.5108-4.045-8.717-3.5414-16.095s2.9057-12.135 5.3652-10.624 4.045 8.717 3.5414 16.095c-0.49952 7.3185-2.8688 12.069-5.3139 10.655"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(30.714 -.714)",
    d: "m385.42 380.31c-10.435-3.4028-17.162-19.633-15.025-36.251s12.328-27.331 22.762-23.929 17.162 19.633 15.025 36.251c-2.1193 16.483-12.171 27.183-22.545 23.998",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(37.785 4.2758)",
    d: "m380.42 367.2c-2.4595-1.5108-4.045-8.717-3.5414-16.095s2.9057-12.135 5.3652-10.624 4.045 8.717 3.5414 16.095c-0.49952 7.3185-2.8688 12.069-5.3139 10.655"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m154.29 310.93c8.5714 31.429 28.498 54.898 45.714 52.857 56.905-6.7468 64.977-69.526 47.143-52.857-44.989 42.049-67.143 10-92.857 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(5.7126 0 0 6.8447 -2080.6 -2362.1)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.4751 0 0 6.9528 -1581.4 -2352.8)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.476 -4.2741 4.1543 6.6111 -3200.3 -400.94)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.4525 -4.769 4.1324 7.3766 -3130.9 -517.54)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.4624 -4.5568 4.1416 7.0484 -3093.2 -456.34)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.4795 -4.2035 4.1575 6.5018 -3066.1 -353.41)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.4658 -4.4861 4.1447 6.939 -3000.9 -431.91)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.536 -3.1466 4.2099 4.8672 -2992.8 -145.34)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.5484 -2.936 4.2215 4.5413 -2960.2 -70.38)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.5162 -3.4983 4.1916 5.4111 -2892.6 -182.24)",
    d: "m406.73 403.36c-1.9463 3.7184-6.9334 4.1845-10.316 2.3074",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.54162
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthworm);
export default __webpack_public_path__ + "static/media/earthworm.cbecc8a39ee13d390e599676f63fef3e.svg";
export { ForwardRef as ReactComponent };